import { ICollaboratorSchema } from "@wingspanhq/payments/dist/interfaces";

const getTin = (collaborator: ICollaboratorSchema) =>
  collaborator.member?.profile?.company?.taxId ||
  collaborator.member?.profile?.ssnLastFour ||
  collaborator.formW9Data?.ein ||
  collaborator.formW9Data?.ssn;

export default getTin;
